"use strict";

var isFunction = require('lodash/isFunction');

var operations = require('../operations');

var computers = require('../computers');

var conditions = require('../conditions');

function unconditional(oldValue, newValue) {
  return newValue;
}

function createReducer(component, quantity, product, tables, priceSettingsForComponent, productLevelParameters, options) {
  function reduceComponentFields(acc, opts) {
    var operation = opts.operation,
        computer = opts.computer,
        condition = opts.condition; // in the settings, we specify an operation (e.g. add, multiply)

    var f = operations[operation] || operations.add; // a computer (e.g. tableLookup, linear, constant)

    var g = computers[computer]; // and an optional condition (e.g boolean, match, greaterThan, lessThan)

    var h = condition ? conditions[condition.comparator] : unconditional; // make sure they're all functions, otherwise this will break.

    if (!isFunction(f)) {
      throw new Error("operations/".concat(operation, " is not a function"));
    }

    if (!isFunction(g)) {
      throw new Error("computers/".concat(computer, " is not a function"));
    }

    if (!isFunction(h)) {
      throw new Error("conditions/".concat(condition.comparator, " is not a function"));
    } // pass the functions the necessary parameters


    var fArgs = {
      opts: opts,
      g: g,
      component: component,
      product: product,
      quantity: quantity,
      tables: tables,
      priceSettingsForComponent: priceSettingsForComponent,
      productLevelParameters: productLevelParameters,
      options: options
    }; // apply the functions to the accumulator

    var next = h(acc, f(acc, fArgs), fArgs); // return the new value

    return next;
  }

  return reduceComponentFields;
}

module.exports = createReducer;